export default class MailerLiteNewsletterForm {
    constructor(elm, args) {
        const form = elm.querySelector('.footer__newsletter__form');
        const submit = elm.querySelector('[type="submit"]');
        const email = elm.querySelector('[name="Email"]');
        const permission = elm.querySelector('[name="Permission"]');
        const culture = elm.querySelector('[name="Culture"]');

        window.submitNewsletter = function () {
            const url = '/umbraco/api/MailerLiteNewsletter/SignupToNewsletter';
            fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: getJson(),
            })
                .then(function (response) {
                    handleResponse(response);
                })
                .catch(err => {
                    handleError(err);
                });

            return true;
        };

        function handleError(err) {
            elm.classList.add('footer__newsletter--error');
        }

        function handleResponse(response) {
            if (response.StatusCode === 200) {
                elm.classList.add('footer__newsletter--success');
            } else {
                elm.classList.add('footer__newsletter--error');
            }

            elm.querySelector('.footer__newsletter__form').style.display = 'none';
        }

        function getJson() {
            debugger;
            return JSON.stringify({ Email: email.value, Permission: permission.value, Culture: culture.value });
        }
    }
}


